import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { HttpMethods } from '@cbre/http';
import { DataObject } from '@shared/models/data-object.model';
import { EntityType } from '@shared/models/entity-enum';
import { Observable } from 'rxjs';

@Injectable()
export class CompareAssociatedFieldsService extends HttpMethods {
  constructor(http: HttpClient) {
    super(http);
  }

  public updateAssociatedRecordsFrom(
    entity: EntityType.LeaseComp | EntityType.Tenancy | EntityType.Availability,
    payload: DataObject
  ): Observable<any> {
    return this.httpPost(`/efficiency/${entity}`, payload);
  }
}
